// Тулбар навигации под доской разбора (стиль контролов зевков/дебютов):
// ⏮ в начало · ◀ назад · ▶ вперёд · ⏭ в конец · ⇅ перевернуть доску.
// Только DOM + состояния кнопок — вся логика (кадр/ориентация) в экране game.ts.
import { t } from '../i18n';

export interface GameNavHandlers {
  onFirst(): void;
  onPrev(): void;
  onNext(): void;
  onLast(): void;
  onFlip(): void;
  onBest(): void;
  onPlay(): void;
}

export interface GameNav {
  el: HTMLElement;
  /** atStart — на стартовой позиции; atEnd — на последнем ходу. */
  setNav(atStart: boolean, atEnd: boolean): void;
  /** Подсветка тоггла 💡 «лучший ход». */
  setBest(active: boolean): void;
  /** Подсветка тоггла 🤖 «игра с движком». */
  setPlay(active: boolean): void;
  /** 💡 считает on-demand стрелку: disabled + пульс. */
  setHintBusy(busy: boolean): void;
}

export function createGameNav(h: GameNavHandlers): GameNav {
  const el = document.createElement('div');
  el.className = 'row between train-toolbar nav-row';
  el.innerHTML = `
    <div class="tb-ctl">
      <button type="button" class="btn" data-nav="first" aria-label="${t('game.nav_first')}">⏮</button>
      <button type="button" class="btn" data-nav="prev" aria-label="${t('game.prev')}">◀</button>
      <button type="button" class="btn" data-nav="next" aria-label="${t('game.next')}">▶</button>
      <button type="button" class="btn" data-nav="last" aria-label="${t('game.nav_last')}">⏭</button>
    </div>
    <div class="tb-ctl">
      <button type="button" class="btn" data-nav="best" aria-label="${t('game.best_toggle')}">💡</button>
      <button type="button" class="btn" data-nav="play" aria-label="${t('play.cta_review')}">🤖</button>
      <button type="button" class="btn" data-nav="flip" aria-label="${t('game.flip')}">⇅</button>
    </div>`;
  const btn = (k: string): HTMLButtonElement => el.querySelector<HTMLButtonElement>(`[data-nav="${k}"]`)!;
  const first = btn('first');
  const prev = btn('prev');
  const next = btn('next');
  const last = btn('last');
  const best = btn('best');
  best.addEventListener('click', h.onBest);
  btn('play').addEventListener('click', h.onPlay);
  first.addEventListener('click', h.onFirst);
  prev.addEventListener('click', h.onPrev);
  next.addEventListener('click', h.onNext);
  last.addEventListener('click', h.onLast);
  btn('flip').addEventListener('click', h.onFlip);
  return {
    setBest(active) { best.classList.toggle('active', active); },
    setPlay(active) { btn('play').classList.toggle('active', active); },
    setHintBusy(busy) {
      best.disabled = busy;
      best.classList.toggle('busy', busy);
    },
    el,
    setNav(atStart, atEnd) {
      first.disabled = prev.disabled = atStart;
      next.disabled = last.disabled = atEnd;
    },
  };
}
